import { gql, MutationResult, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { MutationReturnType } from 'basics/types/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const syncTacticGroupsToVeevaMutationCall = gql`
  mutation syncTacticGroupsToVeeva($cepId: String!) {
    syncTacticGroupsToVeeva(cepId: $cepId)
  }
`;

type ResultType = {
  syncTacticGroupsToVeeva: boolean;
};

type UseSyncTacticGroupsToVeevaMutation = [
  (cepId: string) => Promise<MutationReturnType<boolean>>,
  MutationResult<ResultType>,
];

export const useSyncTacticGroupsToVeevaMutation = (): UseSyncTacticGroupsToVeevaMutation => {
  const [syncTacticGroupsToVeeva, state] = useMutation<ResultType>(syncTacticGroupsToVeevaMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  const executeMutation = useCallback(async (cepId) => {
    try {
      const { data } = await syncTacticGroupsToVeeva({
        variables: {
          cepId,
        },
      });

      return { data: !!data?.syncTacticGroupsToVeeva, error: null };
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'syncTacticGroupsToVeeva.ts - useSyncTacticGroupsToVeevaMutation',
        });

        return { data: null, error: customContext.message as string };
      }

      return { data: null, error: null };
    }
  }, [syncTacticGroupsToVeeva]);

  return [executeMutation, state];
};
